/* eslint-disable @typescript-eslint/no-useless-constructor */
import { SupabaseClient } from '@supabase/supabase-js';
import { Semester } from '@grcs/types/DataTypes';
import { BaseRepository } from '../BaseRepository';
import { DatabaseArrayResult, TABLE_NAMES } from '../types';

/**
 * Semester repository that handles all semester-related database operations
 * Preserves all existing function signatures and business logic
 */
export class SemesterRepository extends BaseRepository {
  constructor(supabase: SupabaseClient<any, 'public', any>) {
    super(supabase);
  }

  /**
   * Preserves exact logic from getAllSemesters
   */
  async getAllSemesters(): Promise<DatabaseArrayResult<Semester>> {
    try {
      const { data, error } = await this.supabase
        .from(TABLE_NAMES.SEMESTER)
        .select('*');

      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  }

  /**
   * Preserves exact logic from getCurrentSemesterYear
   */
  async getCurrentSemesterYear(): Promise<DatabaseArrayResult<Semester>> {
    return this.getDataById(TABLE_NAMES.SEMESTER, 'is_current', 'true');
  }

  /**
   * Preserves exact logic from insertSemester
   */
  async insertSemester(
    semester: Omit<Semester, 'id'>,
  ): Promise<DatabaseArrayResult<Semester>> {
    try {
      const { data, error } = await this.supabase
        .from(TABLE_NAMES.SEMESTER)
        .insert([semester])
        .select();

      if (error) {
        console.error('Error inserting semester:', error);
        return { data: null, error };
      }
      return { data, error: null };
    } catch (error) {
      console.error('Error inserting semester:', error);
      return { data: null, error };
    }
  }
}
